import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyTipStep } from "../../../../actions/mine_craft/tipStepsActions";
import {
  selectTipStepEntities,
  selectTipStepIds,
  setEditId
} from "../../../../store/mine_craft/tipStepsSlice";

import { message, Spin, Image } from "antd";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import IconText from "../../../../componets/IconText";
import { FlagOutlined } from "@ant-design/icons";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const dispatch = useAppDispatch();
  const ids      = useAppSelector(selectTipStepIds);
  const tipSteps = useAppSelector(selectTipStepEntities);
  const count    = useAppSelector(state => state.mineCraft.tipSteps.count);
  const error    = useAppSelector(state => state.mineCraft.tipSteps.error);
  const status   = useAppSelector(state => state.mineCraft.tipSteps.status);

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyTipStep(id));

    if (destroyTipStep.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyTipStep.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderTipStep = (id: EntityId) => {
    const tipStep = tipSteps[id];

    if (!tipStep) {
      return;
    }

    const translationsCount = Object.keys(tipStep.title_translations).length;

    return (
      <CardImage
        key={tipStep.id}
        image={tipStep.image_url}
        title={tipStep.title}
        preview={true}
        stats={[
          <IconText icon={FlagOutlined} text={translationsCount} />
        ]}
        options={[
          <ButtonEdit key={`edit-${tipStep.id}`} onClick={() => onClickEdit(tipStep.id)} />,
          <ButtonDestroy key={`destroy-${tipStep.id}`} onClick={() => onClickDestroy(tipStep.id)} />
        ]}
      />
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      <Image.PreviewGroup>
        {ids && ids.map(renderTipStep)}
      </Image.PreviewGroup>

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
